import Component from 'flarum/common/Component';
import { FIELDS } from './api';

/** The profile form shared by "add", "create", "edit" and AI proposals. attrs: profile (object, edited in place) */
export default class ProfileFields extends Component {
  view() {
    const p = this.attrs.profile;
    return m("div", {
      className: "VEC-fields"
    }, FIELDS.map(_ref => {
      let [key, label, hint] = _ref;
      return m("label", {
        className: 'VEC-field' + (key === 'bio' ? ' is-wide' : '')
      }, m("span", null, label), key === 'bio' ? m("textarea", {
        className: "FormControl",
        rows: "2",
        value: p[key],
        placeholder: hint,
        oninput: e => p[key] = e.target.value
      }) : m("input", {
        className: "FormControl",
        value: p[key],
        placeholder: hint,
        oninput: e => p[key] = e.target.value
      }));
    }));
  }
}